// extracted by mini-css-extract-plugin
export default {"header":"header_header__MmFM3 typography_text--sm__BgKHZ","nav":"header_nav__nma5R","list":"header_list__9u5fO"};